var _style, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1051,
    height: 952,
    viewBox: "0 0 1051 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.path {\n\t\t\t  stroke-dasharray: 2000;\n\t\t\t  stroke-dashoffset: 2000;\n\t\t\t  animation: dash 15s ease infinite;\n\t\t\t}\n\n\t\t\t@keyframes dash {\n\t\t\t  from {\n\t\t\t    stroke-dashoffset: 2000;\n\t\t\t  }\n\t\t\t  to {\n\t\t\t    stroke-dashoffset: 0;\n\t\t\t  }\n\t\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    opacity: 0.5,
    d: "M0.977661 942.679C70.4283 942.679 126.715 886.392 126.715 816.942V726.61C126.715 666.692 175.285 618.122 235.203 618.122H339.455C400.735 618.122 449.305 566.223 444.917 505.095C444.917 504.792 444.917 504.489 444.917 504.338C439.47 431.71 399.827 393.278 408.906 319.893C408.906 319.59 408.906 319.439 409.057 319.136C413.142 287.513 439.319 263.455 471.094 261.79C692.307 250.291 769.626 207.471 794.743 165.558C801.552 154.059 827.425 103.975 880.837 83.5488C901.113 75.8321 919.875 74.4703 932.736 74.6216H963.754C1004.91 74.6216 1038.2 41.3337 1038.2 0.177734",
    stroke: "url(#paint0_linear)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path",
    opacity: 0.5,
    d: "M0.977661 948.732C24.4305 951.607 60.1393 952.666 97.0586 937.232C179.522 902.734 173.016 826.323 245.341 769.431C333.857 699.829 401.038 769.582 504.079 700.585C588.509 644.147 557.34 588.012 640.559 528.396C754.192 447.143 850.424 517.199 914.882 438.216C970.11 370.581 958.761 245.146 947.716 205.655C940.302 179.025 933.795 152.092 928.954 124.856C926.533 111.087 924.566 98.3771 923.053 86.8776C920.329 65.5431 935.914 46.4782 957.4 44.8138C957.551 44.8138 957.702 44.8138 957.854 44.8138C976.918 43.3007 987.661 42.5442 998.858 39.3667C1020.19 33.4656 1043.04 13.6442 1050 7.13794",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "path",
    opacity: 0.5,
    d: "M1.73535 945.706C19.1358 944.949 46.8253 941.62 74.3635 925.884C165.451 874.137 134.433 758.234 235.81 654.89C277.42 612.373 285.136 629.471 341.423 575.605C433.268 487.392 407.999 446.538 468.523 404.777C561.426 340.774 655.237 413.402 742.845 334.873C777.041 304.157 795.349 264.968 795.349 264.968C814.717 223.207 806.546 203.385 825.611 135.145C839.531 85.0621 847.097 59.7936 869.49 45.7219C892.338 31.3475 910.495 40.2747 951.954 34.9789C992.807 29.8345 1025.49 15.0062 1048.79 1.38843",
    stroke: "url(#paint2_linear)",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1030.5,
    y1: 8.99994,
    x2: 1.00112,
    y2: 943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#55628A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1034.5,
    y1: 7.00002,
    x2: -10.4989,
    y2: 950,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#55628A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1029.5,
    y1: 8.00001,
    x2: 2.00101,
    y2: 946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#010305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#5F7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "#060D1B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLines);
export default __webpack_public_path__ + "static/media/header-lines.9541ca79eaac8f60004ab63d433782c6.svg";
export { ForwardRef as ReactComponent };